import {toastr} from '../mixins/toastr';

window.addEventListener('alert', (event) => {
    toastr[event.detail.type](
        event.detail.message,
        event.detail.title ? event.detail.title : null
    );
});